module.exports = "/dist/assets/images/favicon.ico";